import React from 'react';

const badges = [
  { emoji: '🚚', title: 'Delivery in 5–7 Days', sub: 'Pan India Shipping' },
  { emoji: '🔒', title: 'Secure Payments', sub: 'UPI · Cards · COD' },
  { emoji: '🎨', title: '100% Custom Design', sub: 'AI-Powered Artwork' },
  { emoji: '🔁', title: 'Easy Replacement', sub: 'Quality Guarantee' },
  { emoji: '✅', title: '2 Free Revisions', sub: 'Before Printing' },
];

const TrustBadges = () => {
  return (
    <section className="py-4 bg-white border-y border-gray-100">
      {/* Mobile: horizontal scroll */}
      <div className="flex md:hidden gap-0 overflow-x-auto scrollbar-hide px-4">
        {badges.map((badge, i) => (
          <div
            key={i}
            className="flex items-center gap-2.5 px-4 py-3 flex-shrink-0 border-r border-gray-100 last:border-0"
          >
            <span className="text-xl">{badge.emoji}</span>
            <div>
              <p className="text-xs font-semibold text-gray-800 whitespace-nowrap">{badge.title}</p>
              <p className="text-[10px] text-gray-500 whitespace-nowrap">{badge.sub}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop: centered flex */}
      <div className="hidden md:flex justify-center items-center gap-0 max-w-5xl mx-auto px-4">
        {badges.map((badge, i) => (
          <div
            key={i}
            className="flex items-center gap-3 px-6 py-2 border-r border-gray-100 last:border-0 flex-1 justify-center"
          >
            <span className="text-2xl">{badge.emoji}</span>
            <div>
              <p className="text-sm font-semibold text-gray-800">{badge.title}</p>
              <p className="text-xs text-gray-500">{badge.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBadges;
